module.exports = __webpack_public_path__ + "253d5ffaafbbf6948f10790aa5b57c1e.svg";